import { BrowserRouter  as Router, Route, Routes } from "react-router-dom";
import { EmailVerificationLandingPage } from "./pages/app/EmailVerificationLandingPage";
import { ForgotPasswordPage } from "./pages/app/ForgotPasswordPage";
import { LogInPage } from './pages/app/LogInPage';
import { UserInfoPage } from './pages/app/UserInfoPage';
import { SignUpPage } from "./pages/app/SignUpPage";
import { PrivateRoute } from "./auth/PrivateRoute";
import { VerifyEmailPage } from "./pages/app/VerifyEmailPage";
import { PasswordResetLandingPage } from "./pages/app/PasswordResetLandingPage";
import { SignupNotification } from "./pages/app/SignupNotification";
import { Household } from "./pages/app/Household";
import { Pantry } from "./pages/app/Pantry";
import { KrogerLogin } from "./pages/app/KrogerLogin";
import { HomePage } from "./pages/marketing/HomePage/HomePage";
import { FeaturePage } from "./pages/marketing/FeaturePage/FeaturePage";
import { AboutPage } from "./pages/marketing/AboutPage/AboutPage";
import { ContactPage } from "./pages/marketing/ContactPage/ContactPage";

export const RoutePath = () => {
  return (
    <Router>
        <Routes>
            <Route path="/settings"
              element={
                <PrivateRoute>
                  <UserInfoPage />
                </PrivateRoute>
                } />
            // Main Site
            <Route path="/login" element={<LogInPage />} />
            <Route path="/signup" element={<SignUpPage />} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />
            <Route path="/verify-email/:verificationString" element={<EmailVerificationLandingPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password/:passwordResetCode" element={<PasswordResetLandingPage />} />
            <Route path="/notify" element={<SignupNotification />} />
            <Route path="/household" element={<Household />} />
            <Route path="/pantry" element={<Pantry />} />
            <Route path="/kroger" element={<KrogerLogin />} />

            // Sales Front End
            <Route path="/" element={<HomePage />} />
            <Route path="/features" element={<FeaturePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
        </Routes>
    </Router>
  )
}
